import { runtimeConfig } from './runtimeConfig';

export const config = {
  AUTH0_AUDIENCE: runtimeConfig.AUTH0_AUDIENCE,
  AUTH0_REDIRECT_URL: `${runtimeConfig.APP_URL}/callback`,
  AUTH0_LOGOUT_URL: `${runtimeConfig.APP_URL}/logout`,
  AUTH0_DOMAIN: runtimeConfig.AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: runtimeConfig.AUTH0_CLIENT_ID,
};
